import {Injectable} from '@angular/core';
import {DaoGeneric} from '@Services/base/daoService';
import {HttpClient} from '@angular/common/http';
import {environment} from '@Env/environment';
import {DepositLocation} from "app/archivage/common/services/deposit/deposit.model";

@Injectable({
  providedIn: 'root'
})
export class LocationService extends DaoGeneric<DepositLocation> {
  private urlAction = `${environment.baseUrl}/api_archive/location/`;

  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getRootUrl(): string {
    return this.urlAction;
  }

  /**
   * <Magasin>_[<EPI>_]<Travée>_<Rayonnage>_<Tablette>
   * @param {DepositLocation} loc
   */
  displayLocation(loc: DepositLocation) {
    if (loc?.magasin_obj) {
      const mag = `${loc.magasin_obj.label}_`;
      const epi = (loc.epi) ? `${loc.epi}_` : '';
      return `${mag}${epi}${loc.tra}_${loc.ray}_${loc.tab}`;
    }
    return '';
  }
}
